<div class="filter" [formGroup]="form">
  <div class="filter__inputs">
    <!-- Search -->
    <div class="filter__input">
      <label class="filter__label" for="searchTerm" i18n="@@sr_list.filter.search">Search</label>
      <input
        pInputText
        id="searchTerm"
        placeholder="Search"
        i18n-placeholder="@@sr_list.filter.search"
        formControlName="searchTerm" />
    </div>
    <!-- Status -->
    <div class="filter__input">
      <label class="filter__label" for="status" i18n="@@sr_list.filter.status">Status</label>
      <p-multiselect
        id="status"
        placeholder="Status"
        i18n-placeholder="@@sr_list.filter.status"
        formControlName="status"
        optionLabel="name"
        [options]="statusOptions" />
    </div>
    <!-- Severity -->
    <div class="filter__input">
      <label class="filter__label" for="severity" i18n="@@sr_list.filter.severity">Severity</label>
      <p-select
        id="severity"
        placeholder="Severity"
        i18n-placeholder="@@sr_list.filter.severity"
        formControlName="severity"
        optionLabel="name"
        [options]="levelOptions" />
    </div>
    <!-- Urgency -->
    <div class="filter__input">
      <label class="filter__label" for="urgency" i18n="@@sr_list.filter.urgency">Urgency</label>
      <p-select
        id="urgency"
        placeholder="Urgency"
        i18n-placeholder="@@sr_list.filter.urgency"
        formControlName="urgency"
        optionLabel="name"
        [options]="levelOptions" />
    </div>
    <!-- Requester -->
    <div class="filter__input">
      <label class="filter__label" for="requester" i18n="@@sr_list.filter.requester"
        >Requester (email)</label
      >
      <input
        pInputText
        id="requester"
        placeholder="Requester (email)"
        i18n-placeholder="@@sr_list.filter.requester"
        formControlName="requester" />
    </div>
    <!-- Critical -->
    <div class="filter__input">
      <label class="filter__label" for="critical" i18n="@@sr_list.filter.critical">Critical</label>
      <p-select
        id="critical"
        placeholder="Critical"
        i18n-placeholder="@@sr_list.filter.critical"
        formControlName="critical"
        optionLabel="name"
        [options]="criticalOptions" />
    </div>
  </div>
  <div class="filter__actions">
    <p-button
      label="Filter"
      i18n-label="@@common.button.filter"
      icon="pi pi-search"
      class="filter__button"
      (click)="filter()">
    </p-button>
    <p-button
      label="Clear"
      i18n-label="@@common.button.clear"
      icon="pi pi-filter-slash"
      class="filter__button filter__button--clear"
      [outlined]="true"
      [disabled]="isClearButtonDisabled()"
      severity="danger"
      (click)="clearFilter()">
    </p-button>
  </div>
</div>
